/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Icon } from '../../ui/Icon';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { backToTopButtonCss, backToTopIconCss } from './index.styles';

function goToTop() {
  window.scrollTo(window.scrollX, 0);
}

class BackToTop extends SafePureComponent {
  safeRender() {
    const { props } = this;

    return (
      <div className={props.className}>
        <button
          data-testid="back-to-top"
          css={backToTopButtonCss}
          onClick={goToTop}
        >
          <Icon customCss={backToTopIconCss} name="arrow-right" />
        </button>
      </div>
    );
  }
}

BackToTop.displayName = 'BackToTop';

export default BackToTop;
